import Layout from '@4c/layout';
import styled from 'astroturf'
import classNames from 'classnames';
import React from 'react';
import NavbarBrand from './NavbarBrand';
import NavbarButton from './NavbarButton';
import NavbarNavItem from './NavbarNavItem';
import { ThemeProvider } from './ThemeContext';
export const styles = require('./Navbar-styles.module.scss');

/**
 * Also exports:
 *
 * - `Navbar.Brand` A logo and/text in the Navbar.
 * - `Navbar.NavItem` a styled nav entry, with active states.
 * - `Navbar.Divider` Visually seperate like groups of items.
 * - `Navbar.Button` A basic button for use in a Navbar, build dropdowns etc with it.
 */
function Navbar({
  style,
  className,
  children
}) {
  return React.createElement(ThemeProvider, {
    theme: "dark"
  }, React.createElement(Layout, {
    style: style,
    align: "center",
    justify: "flex-start",
    className: classNames(className, styles.container)
  }, children));
}

Navbar.Brand = NavbarBrand;
Navbar.Button = NavbarButton;
Navbar.NavItem = NavbarNavItem;
Navbar.Divider = /*#__PURE__*/styled('div', null, {
  displayName: "NavbarDivider",
  styles: require("./Navbar-NavbarDivider.module.scss"),
  attrs: null,
  vars: []
});
export default Navbar;